module.exports = __webpack_public_path__ + "img/lookResult.de1a13cd.png";